<template>
  <v-container fluid full-height grid-list-md>
    <v-layout row wrap>
      <v-flex xs6>
        <div class="text-xs-left">
          <v-breadcrumbs :items="breadcrumbs" divider=">"></v-breadcrumbs>
        </div>
      </v-flex>
      <v-flex xs6>
        <div style="display: flex; justify-content: flex-end">
          <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn color="primary" v-bind="attrs" v-on="on">
                <v-icon>add_circle</v-icon>Add
              </v-btn>
            </template>
            <v-list>
              <v-list-tile @click="onRegister">
                <v-list-tile-content>
                  <v-list-tile-title>ADD NEW</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>

              <v-list-tile @click="openDialog = true">
                <v-list-tile-content>
                  <v-list-tile-title>IMPORT EXCEL</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
            </v-list>
          </v-menu>

          <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                color="success"
                :loading="buttonLoading"
                v-bind="attrs"
                v-on="on"
                ><v-icon>cloud_download</v-icon>Export</v-btn
              >
            </template>

            <v-list>
              <v-list-tile @click="exportAllMachines()">
                <v-list-tile-content>
                  <v-list-tile-title>EXPORT ALL</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
            </v-list>
          </v-menu>

          <v-btn @click="showFilters = !showFilters" color="#FF4545">
            <v-icon>filter_list</v-icon>Filter
            <v-icon>{{
              showFilters ? "arrow_drop_up" : "arrow_drop_down"
            }}</v-icon>
          </v-btn>
        </div>
      </v-flex>
      <v-flex xs12 v-if="showFilters">
        <v-card>
          <v-layout row wrap class="pa-3">
            <v-flex sm3>
              <v-select
                :items="shopList"
                label="Select Shop"
                v-model="queryParams.shopId"
                item-text="name"
                item-value="id"
                :readonly="checkUserShop() ? true : false"
              ></v-select>
            </v-flex>
            <v-flex sm3>
              <v-select
                :items="branchList"
                label="Select Branch"
                v-model="queryParams.branchId"
                item-text="name"
                item-value="id"
                :readonly="checkUserBranch() ? true : false"
              ></v-select>
            </v-flex>
            <v-flex sm3>
              <v-select
                :items="departmentList"
                label="Select Department"
                v-model="queryParams.departmentId"
                item-text="name"
                item-value="id"
              ></v-select>
            </v-flex>
            <v-flex sm3>
              <v-select
                :items="machineTypeList"
                label="Select Machine Type"
                v-model="queryParams.machineTypeId"
                item-text="name"
                item-value="id"
              ></v-select>
            </v-flex>
            <v-flex sm3>
              <v-text-field
                name="codeOrName"
                label="Code/Name"
                type="text"
                v-model="queryParams.codeOrName"
              ></v-text-field>
            </v-flex>
            <v-flex sm3>
              <v-text-field
                name="model"
                label="Model"
                type="text"
                v-model="queryParams.model"
              ></v-text-field>
            </v-flex>
            <v-flex sm3>
              <v-select
                :items="countryList"
                label="Select Country Of Origin"
                v-model="queryParams.countryId"
                item-text="name"
                item-value="id"
                :hide-no-data="true"
              ></v-select>
            </v-flex>
            <v-flex sm3>
              <v-text-field
                name="installationData"
                label="Installation Data"
                type="text"
                v-model="queryParams.installationData"
              ></v-text-field>
            </v-flex>
            <v-flex sm3>
              <v-select
                :items="maintenanceTypeList"
                label="Select Maintenance Type"
                v-model="queryParams.maintenanceTypeId"
                item-text="name"
                item-value="id"
              ></v-select>
            </v-flex>
            <v-flex sm3>
              <v-select
                :items="maintenanceFrequencyList"
                label="Select Maintenance Frequency"
                v-model="queryParams.maintenanceFrequencyId"
                item-text="name"
                item-value="id"
              ></v-select>
            </v-flex>
            <v-flex sm3>
              <v-select
                :items="statusList"
                label="Status"
                v-model="queryParams.status"
                item-text="label"
                item-value="value"
              ></v-select>
            </v-flex>
            <v-flex sm3>
              <v-btn outline color="primary" @click="onSearch">
                Search
                <v-icon right>search</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
      <v-flex xs12 class="mt-1">
        <v-card>
          <v-data-table
            :headers="headers"
            :items="machineList"
            class="elevation-1"
            :loading="showListLoading"
            :total-items="totalRows"
            :rows-per-page-items="rowsPerPageItems"
            :pagination.sync="pagination"
            :must-sort="true"
          >
            <template slot="items" slot-scope="props">
              <td>
                <v-btn
                  flat
                  icon
                  color="blue lighten-2"
                  @click.stop="onEdit(props.item)"
                >
                  <v-icon>edit</v-icon>
                </v-btn>
              </td>
              <td>
                <v-icon
                  v-if="props.item.status == 'ACTIVE'"
                  medium
                  color="green"
                  >check_circle</v-icon
                >
                <v-icon
                  v-else-if="props.item.status == 'SERVICEABLE'"
                  medium
                  color="orange"
                  >check_circle</v-icon
                >
                <v-icon v-else medium color="red">cancel</v-icon>
              </td>
              <td>{{ props.item.shopName }}</td>
              <td>{{ props.item.branchName }}</td>
              <td>{{ props.item.departmentName }}</td>
              <td>{{ props.item.machineTypeName }}</td>
              <td>{{ props.item.code + " / " + props.item.name }}</td>
              <td>{{ props.item.qty + " / " + props.item.unitName }}</td>
              <td>{{ props.item.model }}</td>
              <td>{{ props.item.capacity }}</td>
              <td>{{ props.item.countryName }}</td>
              <td>{{ props.item.installationData }}</td>
              <td>{{ props.item.lifeCycle }}</td>
              <td>{{ props.item.maintenanceTypeName }}</td>
              <td>{{ props.item.maintenanceFrequencyName }}</td>
              <td>
                {{ props.item.updatedDateInMilliSeconds | formatMsDateTime }}
              </td>
              <td>{{ props.item.updatedBy }}</td>
            </template>
          </v-data-table>
        </v-card>
      </v-flex>
    </v-layout>
    <machineExcel
      :isOpen="openDialog"
      v-on:change="dialogClose()"
    ></machineExcel>
  </v-container>
</template>

<script>
import { machineService } from "../../services/machine-service";
import { commonService } from "../../services/common-service";
import { shopService } from "../../services/shop-service";
import { branchService } from "../../services/branch-service";
import { departmentService } from "../../services/department-service";
import { machineTypeService } from "../../services/machine-type-service";
import { countryService } from "../../services/country-service";
import { maintenanceTypeService } from "../../services/maintenance-type-service";
import { maintenanceFrequencyService } from "../../services/maintenance-frequency-service";
import machineExcel from "../../components/machine/MachineExcel";

export default {
  name: "MachineList",
  components: { machineExcel },
  data: () => ({
    user: JSON.parse(localStorage.getItem("user")),
    showListLoading: false,
    buttonLoading: false,
    showFilters: false,
    breadcrumbs: [
      {
        text: "Asset Management",
        disabled: true,
      },
      {
        text: "Machine",
        disabled: true,
      },
    ],
    openDialog: false,
    headers: [
      { text: "Action", sortable: false },
      { text: "Status", value: "status", sortable: false },
      { text: "Shop", align: "left", value: "shop.name" },
      { text: "Branch ", value: "branch.name" },
      { text: "Department", value: "department.name" },
      { text: "Machine Type", value: "machine.name" },
      { text: "Code/Name", sortable: false },
      { text: "Qty/Unit", sortable: false },
      { text: "Model", value: "model" },
      { text: "Capacity", value: "capacity" },
      { text: "Country Of Origin", value: "countryId" },
      { text: "Installation Data", value: "installationData" },
      { text: "Life Cycle", value: "lifeCycle" },
      { text: "Maintenance Type", value: "maintenanceType.name" },
      { text: "Maintenance Frequency", value: "maintenanceFrequency.name" },
      { text: "Updated Date", value: "updatedDate" },
      { text: "Updated By", value: "updatedBy" },
    ],
    statusList: [
      { label: "All", value: "" },
      { label: "ACTIVE", value: "ACTIVE" },
      { label: "INACTIVE", value: "INACTIVE" },
      { label: "SERVICEABLE", value: "SERVICEABLE" },
    ],
    rowsPerPageItems: [25, 50, 100],
    shopList: [],
    branchList: [],
    departmentList: [],
    machineTypeList: [],
    maintenanceTypeList: [],
    countryList: [],
    maintenanceFrequencyList: [],
    machineList: [],
    pagination: {
      descending: true,
      page: 1,
      rowsPerPage: 50,
      sortBy: "updatedDate",
      totalItems: 0,
    },
    queryParams: {
      shopId: "",
      branchId: "",
      departmentId: "",
      machineTypeId: "",
      codeOrName: "",
      model: "",
      installationData: "",
      maintenanceTypeId: "",
      countryId: "",
      maintenanceFrequencyId: "",
      status: "ACTIVE",
      isAddDetails: false,
    },
    totalRows: 0,
  }),
  watch: {
    pagination: {
      handler() {
        this.getMachineList();
      },
      deep: true,
    },
  },
  created() {
    //bind filter for user roles
    this.queryParams.shopId = this.checkUserShop();
    this.queryParams.branchId = this.checkUserBranch();

    this.getShopList();
    this.getActiveBranchList();
    this.getActiveDepartmentList();
    this.getActiveMachineTypeList();
    this.getActiveMaintenanceTypeList();
    this.getActiveCountryList();
    this.getActiveMaintenanceFrequencyList();

    //for deep linking
    if (this.$route.query.shopId) {
      this.queryParams.shopId = Number(this.$route.query.shopId);
    }
    if (this.$route.query.branchId) {
      this.queryParams.branchId = Number(this.$route.query.branchId);
    }
    if (this.$route.query.departmentId) {
      this.queryParams.departmentId = Number(this.$route.query.departmentId);
    }
    if (this.$route.query.machineTypeId) {
      this.queryParams.machineTypeId = Number(this.$route.query.machineTypeId);
    }
    if (this.$route.query.codeOrName) {
      this.queryParams.codeOrName = this.$route.query.codeOrName;
    }
    if (this.$route.query.model) {
      this.queryParams.model = this.$route.query.model;
    }
    if (this.$route.query.countryId) {
      this.queryParams.countryId = Number(this.$route.query.countryId);
    }
    if (this.$route.query.installationData) {
      this.queryParams.installationData = this.$route.query.installationData;
    }
    if (this.$route.query.maintenanceTypeId) {
      this.queryParams.maintenanceTypeId = Number(this.$route.query.maintenanceTypeId);
    }
    if (this.$route.query.maintenanceFrequencyId) {
      this.queryParams.maintenanceFrequencyId = Number(this.$route.query.maintenanceFrequencyId);
    }
    if (this.$route.query.isAddDetails) {
      this.queryParams.isAddDetails = this.$route.query.isAddDetails;
    }
    if (this.$route.query.status) {
      this.queryParams.status = this.$route.query.status;
    }
    if (this.$route.query.page) {
      this.pagination.page = this.$route.query.page;
    }
    if (this.$route.query.size) {
      this.pagination.size = this.$route.query.size;
    }
  },
  methods: {
    checkUserShop() {
      if (
        this.user.role.roleName == "BRANCH_ADMIN" ||
        this.user.role.roleName == "ASSET_MANAGER"
      ) {
        return this.user.shopId;
      } else {
        return "";
      }
    },
    checkUserBranch() {
      // if (this.user.role.roleName == "ASSET_MANAGER") {
      //   return this.user.branchId;
      // } else {
      return "";
      // }
    },
    getShopList() {
      shopService
        .getAllShop()
        .then((res) => {
          this.shopList = res.data;
          this.shopList.unshift({ id: "", name: "---ALL---" });
        })
        .catch((err) => {
          console.error(err);
        });
    },
    getActiveBranchList() {
      branchService
        .getBranchByStatus("ACTIVE")
        .then((res) => {
          this.branchList = res.data;
          this.branchList.unshift({ id: "", name: "---ALL---" });
        })
        .catch((err) => {
          console.error(err);
        });
    },
    getActiveDepartmentList() {
      departmentService
        .getDepartmentsByStatus("ACTIVE")
        .then((res) => {
          this.departmentList = res.data;
          this.departmentList.unshift({ id: "", name: "---ALL---" });
        })
        .catch((err) => {
          console.error(err);
        });
    },
    getActiveMachineTypeList() {
      machineTypeService
        .getMachineTypeByStatus("ACTIVE")
        .then((res) => {
          this.machineTypeList = res.data;
          this.machineTypeList.unshift({ id: "", name: "---ALL---" });
        })
        .catch((err) => {
          console.error(err);
        });
    },
    getActiveMaintenanceTypeList() {
      maintenanceTypeService
        .getMaintenanceTypesByStatus("ACTIVE")
        .then((res) => {
          this.maintenanceTypeList = res.data;
          this.maintenanceTypeList.unshift({ id: "", name: "---ALL---" });
        })
        .catch((err) => {
          console.error(err);
        });
    },
    getActiveCountryList() {
      countryService
        .getCountryByStatus("ACTIVE")
        .then((res) => {
          this.countryList = res.data;
          this.countryList.unshift({ id: "", name: "---ALL---" });
        })
        .catch((err) => {
          console.error(err);
        });
    },
    getActiveMaintenanceFrequencyList() {
      maintenanceFrequencyService
        .getMaintenanceFrequencyByStatus("ACTIVE")
        .then((res) => {
          this.maintenanceFrequencyList = res.data;
          this.maintenanceFrequencyList.unshift({ id: "", name: "---ALL---" });
        })
        .catch((err) => {
          console.error(err);
        });
    },
    onSearch() {
      this.queryParams.page = this.pagination.page;
      this.queryParams.size = this.pagination.rowsPerPage;
      this.$router.replace({ name: "machines", query: this.queryParams });
      this.getMachineList();
    },
    onRegister() {
      this.$router.push("/machine/new");
    },
    onEdit(machine) {
      // go to details page
      this.$router.push("/machine/" + machine.id);
    },
    getMachineList() {
      this.showListLoading = true;
      let order = this.pagination.descending ? "desc" : "asc";
      this.queryParams.isAddDetails = false;
      machineService
        .getMachineList(
          this.queryParams,
          this.pagination.page,
          this.pagination.rowsPerPage,
          this.pagination.sortBy + "," + order
        )
        .then((res) => {
          if (res.data) {
            this.machineList = res.data.machineList;
            this.totalRows = res.data.totalElements;
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.showListLoading = false;
        });
    },
    dialogClose() {
      this.openDialog = false;
      this.getMachineList();
    },
    exportAllMachines() {
      this.buttonLoading = true;
      this.queryParams.isAddDetails = true;
      machineService
        .getMachineExcelExport(this.queryParams)
        .then((res) => {
          commonService.downloadE(res);
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.buttonLoading = false;
        });
    },
  },
};
</script>
